import { render, staticRenderFns } from "./SimpleDateCAChart.vue?vue&type=template&id=2db76e5a&scoped=true"
import script from "./SimpleDateCAChart.vue?vue&type=script&lang=js"
export * from "./SimpleDateCAChart.vue?vue&type=script&lang=js"
import style0 from "./SimpleDateCAChart.vue?vue&type=style&index=0&id=2db76e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db76e5a",
  null
  
)

export default component.exports